"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableTextarea = void 0;
var tslib_1 = require("tslib");
var kebabCase_1 = (0, tslib_1.__importDefault)(require("lodash/kebabCase"));
var react_1 = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var test_helpers_1 = require("../../lib/test-helpers");
var button_1 = require("../button");
var spacing_1 = require("../spacing");
var textarea_autosize_1 = require("../textarea-autosize");
function EditableTextarea(_a) {
    var onCancel = _a.onCancel, onSave = _a.onSave, _b = _a.loading, loading = _b === void 0 ? false : _b, propTestId = _a.testId, placeholder = _a.placeholder, textareaProps = (0, tslib_1.__rest)(_a, ["onCancel", "onSave", "loading", "testId", "placeholder"]);
    var textareaRef = (0, react_1.useRef)();
    var testId = propTestId !== null && propTestId !== void 0 ? propTestId : (0, test_helpers_1.generateTestId)((0, kebabCase_1.default)(placeholder), 'editable-textarea');
    function handleKeyDown(e) {
        if (e.key.toLowerCase() === 'escape') {
            onCancel();
        }
        else if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'enter') {
            onSave(e.currentTarget.value);
        }
    }
    return (react_1.default.createElement(StyledContainer, null,
        react_1.default.createElement(textarea_autosize_1.TextareaAutosize, (0, tslib_1.__assign)({ ref: textareaRef, style: {
                paddingBottom: 62,
            }, onKeyDown: handleKeyDown, "data-testid": testId }, textareaProps)),
        react_1.default.createElement(StyledActions, null,
            react_1.default.createElement(button_1.Button, { minWidth: 67, size: "secondary", style: {
                    height: 32,
                    lineHeight: '32px',
                    padding: '6px 11px',
                    display: 'inline-flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }, disabled: loading, onClick: function () {
                    onCancel();
                }, testId: (0, test_helpers_1.generateTestId)(testId, 'cancel-button') }, "Cancel"),
            react_1.default.createElement(spacing_1.Spacing, { width: 8 }),
            react_1.default.createElement(button_1.Button, { minWidth: 67, size: "secondary", style: {
                    height: 32,
                    lineHeight: '32px',
                    padding: '6px 11px',
                    display: 'inline-flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }, loading: loading, onClick: function () { var _a; return onSave(((_a = textareaRef.current) === null || _a === void 0 ? void 0 : _a.value) || ''); }, testId: (0, test_helpers_1.generateTestId)(testId, 'save-button') }, "Save"))));
}
exports.EditableTextarea = EditableTextarea;
var StyledContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var StyledActions = styled_components_1.default.div(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  position: absolute;\n  bottom: 16px;\n  right: 16px;\n  display: flex;\n  align-items: center;\n"], ["\n  position: absolute;\n  bottom: 16px;\n  right: 16px;\n  display: flex;\n  align-items: center;\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map